import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicNav = () => {
  const auth = useAuth();
  const isAuthenticated = auth?.isAuthenticated || auth?.user
    || !!localStorage.getItem('token');

  return (
    <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-brand-border">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">

        {/* LEFT — Logo + wordmark */}
        <Link
          to={isAuthenticated ? '/dashboard' : '/welcome'}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/logo.jpg"
            alt="SkillDelivery"
            className="h-7 w-auto"
          />
          <span className="font-bold text-base sm:text-lg tracking-tight text-brand-text">
            Skill<span className="text-brand-cyan">Delivery</span>
          </span>
        </Link>

        {/* RIGHT — Auth-aware buttons */}
        <div className="flex items-center gap-2 sm:gap-3">
          {isAuthenticated ? (
            <Link
              to="/dashboard"
              className="inline-flex items-center justify-center px-4 sm:px-5 py-2 rounded-brand bg-gradient-to-br from-brand-cyanLight to-brand-blue text-white font-semibold text-sm shadow-brandButton hover:shadow-brandButtonHover hover:-translate-y-px transition-all duration-200"
            >
              Go to Dashboard
              <span className="ml-1">→</span>
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="hidden sm:inline-flex items-center justify-center px-4 py-2 text-sm text-brand-text hover:text-brand-cyan font-medium transition-colors"
              >
                Sign in
              </Link>
              <Link
                to="/register"
                className="inline-flex items-center justify-center px-4 sm:px-5 py-2 rounded-brand bg-gradient-to-br from-brand-cyanLight to-brand-blue text-white font-semibold text-sm shadow-brandButton hover:shadow-brandButtonHover hover:-translate-y-px transition-all duration-200"
              >
                Sign up free
                <span className="ml-1">→</span>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PublicNav;
